import tokenUpdate from "./tokenUpdate";

function getPublicHeaders() {
  const parts = window.location.pathname.split("/");
  return {
    baseUrl: window?.config?.REACT_APP_BASE_URL ?? "",
    headers: {
      "Content-Type": "application/json",
      Authorization: parts[6] ? `Bearer ${parts[6]}` : "",
      "x-map-id": parts[5] ?? "",
    },
  };
}

async function getPrivateHeaders() {
  const baseUrl = window?.config?.REACT_APP_BASE_URL ?? "";
  const stored = JSON.parse(localStorage.getItem("1") || "null");
  const acesso = JSON.parse(localStorage.getItem("acesso") || "null");
  if (stored?.token) await tokenUpdate(stored.token);
  const fresh = JSON.parse(localStorage.getItem("1") || "null");
  return {
    baseUrl,
    headers: {
      "Content-Type": "application/json",
      Authorization: fresh?.token ? `Bearer ${fresh.token}` : "",
      "x-user-id": fresh?.refreshToken?.usuarioClienteId ?? "",
      "x-acess-id": acesso?.[0]?.acessoClientesId ?? "",
    },
  };
}

/**
 * Faz um POST que retorna um stream de frames length-prefixed (uint32 LE + bytes).
 * Chama onChunk(Uint8Array) para cada frame completo recebido.
 *
 * @param {string} path - Caminho relativo, ex: "/easyMaps/onus/findMany"
 * @param {any} body - Corpo da requisição (será serializado como JSON)
 * @param {(frame: Uint8Array) => void} onChunk - Callback chamado para cada frame decodificado
 * @param {boolean} isPublic - Usa headers públicos quando true
 */
export async function streamPost(path, body, onChunk, isPublic = false) {
  const { baseUrl, headers } = isPublic
    ? getPublicHeaders()
    : await getPrivateHeaders();

  const response = await fetch(`${baseUrl}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok || !response.body) {
    throw new Error(`HTTP error ${response.status}`);
  }

  const reader = response.body.getReader();
  let remainder = new Uint8Array(0);

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const combined = new Uint8Array(remainder.length + value.length);
    combined.set(remainder);
    combined.set(value, remainder.length);
    remainder = combined;

    let offset = 0;
    while (remainder.length - offset >= 4) {
      const msgLen = new DataView(
        remainder.buffer,
        remainder.byteOffset + offset,
        4,
      ).getUint32(0, true);

      if (remainder.length - offset - 4 < msgLen) break;

      onChunk(remainder.subarray(offset + 4, offset + 4 + msgLen));
      offset += 4 + msgLen;
    }

    remainder = remainder.slice(offset);
  }
}
